import { z } from "zod/v4";
export const createCampaignInputSchema = z.object({
    name: z.string().min(1),
    document: z.record(z.string(), z.unknown()),
});
export const updateCampaignInputSchema = z.object({
    name: z.string().min(1).optional(),
    document: z.record(z.string(), z.unknown()).optional(),
});
export const joinCampaignInputSchema = z.object({
    joinCode: z.string().min(1),
});
export const updateMemberRoleInputSchema = z.object({
    role: z.enum(["gm", "player"]),
});
export const updateJoinCodeInputSchema = z.object({
    selfJoinEnabled: z.boolean().optional(),
    regenerate: z.boolean().optional(),
});
